import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { AppTypeDataProvider } from "../../data-provider/app-type.dp";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { Effort } from "../../models/effort.model";
import { ChartHelper } from "../result/chart.helper";
import { SurveyService } from "../../services/survey.service";
import { PermissionCheck } from "../../shared/permission";

let SurveyResultsSectionComponent = {
    selector: "vcSurveyResultsSection",
    templateUrl:
        "/angular/components/survey/survey-results-section.component.html",
    bindings: {
        sid: "=",
        showName: "=",
        surveyQuestions: "=?",
    },
    controller: class SurveyResultsSectionController {
        // * bindings for typescript compiler *
        public sid: any;
        public showName: any;
        public surveyQuestions?: any;
        // ************************************

        private app_type: string;
        public url: any;
        public loading = true;
        public efforts: Effort[];
        public effort: Effort;
        public survey: object;
        public activeCampaign: object;
        public gid: string | number;
        public permissionProvider: PermissionCheck;

        private $scope: any;
        private $location: any;
        public __env: any;

        private chartHelper: ChartHelper;
        private effortDataProvider: EffortDataProvider;
        private service: SurveyService;
        private campaignDataProvider: CampaignDataProvider;
        private appTypeDataProvider: AppTypeDataProvider;

        constructor(
            $scope: any,
            EffortDataProvider: EffortDataProvider,
            SurveyService: SurveyService,
            $location: any,
            ChartHelper: ChartHelper,
            PermissionCheck: PermissionCheck,
            CampaignDataProvider: CampaignDataProvider,
            AppTypeDataProvider: AppTypeDataProvider,
            __env: any
        ) {
            this.$scope = $scope;
            this.effortDataProvider = EffortDataProvider;
            this.$location = $location;
            this.__env = __env;
            this.permissionProvider = PermissionCheck;

            this.service = SurveyService;
            this.chartHelper = ChartHelper;
            this.campaignDataProvider = CampaignDataProvider;
            this.appTypeDataProvider = AppTypeDataProvider;

            this.app_type = this.appTypeDataProvider.getAppType();
            this.url = this.$location.search();
            if (!angular.equals({}, this.url)) {
                this.app_type = this.url.app_type;
            }
            this.activeCampaign = this.campaignDataProvider.activeCampaign;

            this.permissionProvider.getFeaturePermissions();

            this.$scope.$watch(
                () => this.effort,
                (newValue: Effort, oldValue: Effort) => {
                    if (oldValue && newValue !== oldValue) {
                        this.loadSurveyData(
                            this.survey,
                            this.effort,
                            this.app_type
                        );
                        this.effortDataProvider.setSelectedEffort(newValue);
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.app_type,
                (newValue: string, oldValue: string) => {
                    if (oldValue && newValue !== oldValue) {
                        this.loadSurveyData(
                            this.survey,
                            this.effort,
                            this.app_type
                        );
                        this.appTypeDataProvider.setAppType(newValue);
                    }
                }
            );
        }

        $onInit() {
            this.effortDataProvider
                .getAllEfforts()
                .then((efforts: Effort[]) => {
                    this.efforts = efforts;

                    this.effortDataProvider
                        .getSelectedEffort()
                        .then((effort: Effort) => {
                            this.effort = effort;
                            this.survey = { sid: this.sid };
                            this.loadSurveyData(
                                this.survey,
                                this.effort,
                                this.app_type
                            );
                        });
                });
        }

        loadSurveyData(survey?: any, effort?: Effort, apptype?: string): void {
            this.loading = true;
            if (!survey) {
                return;
            }
            let effID: string | number, svID: string | number;
            effID = effort.id;
            if (survey) svID = survey.sid;
            this.service
                .info(svID, {
                    gid: this.gid,
                    category: apptype,
                    effortid: effID,
                })
                .then((response: object) => {
                    const json = response["data"];
                    if (json.success) {
                        survey.questions = [];
                        _.merge(survey, json.data);

                        let i = 0;
                        angular.forEach(survey.questions, (question: any) => {
                            if (question.atid != "3") {
                                question.total =
                                    this.chartHelper.calculateSurveyChartDetails(
                                        question.choices,
                                        this.chartHelper.colorPalettes[i % 8]
                                    );
                                i++;
                                angular.forEach(
                                    question.choices,
                                    (choice: any) => {
                                        choice.label = choice.aname;
                                    }
                                );
                            } else {
                                angular.forEach(
                                    json.data.questions,
                                    (free_text_question: any) => {
                                        if (
                                            question.sqid ==
                                            free_text_question.sqid
                                        ) {
                                            question.given_answers =
                                                free_text_question.given_answers;
                                        }
                                    }
                                );
                            }

                            if (question.atid == "5") {
                                question.choices.forEach((choice: any) => {
                                    choice.percent =
                                        (parseInt(choice.count) /
                                            question.totalAnswers) *
                                        100;
                                });
                                question.barData =
                                    this.generateChecklistBarData(question);
                            }
                        });
                        this.loading = false;
                    } else {
                        survey.questions = [];
                    }
                });
        }

        generateChecklistBarData(question: any): any {
            let key = question.sqname;
            let values = question.choices.map((choice: any) => {
                return {
                    label: choice.aname,
                    count: choice.count,
                    color: choice.color,
                    percent: choice.percent,
                    series: 0,
                };
            });
            return [{ key: key, values: values }];
        }
    },
};

angular
    .module("survey")
    .component(
        SurveyResultsSectionComponent.selector,
        SurveyResultsSectionComponent
    );
